module.exports = __webpack_public_path__ + "images/videoCaseStudy-icon-connection.svg?h=c9e991fecc50c0b7d14f9ce6d35e9229";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/videoCaseStudy-icon-connection.svg
// module id = 1602
// module chunks = 12 15